import { Enum } from "./Enum";

export const E_UPLOADS = {
  MAIN:(id:string)=>`/asset/${id}`,
  IMAGE: "/asset/image",
  VIDEO: "/asset/video",
};

export type EUpload = Enum<typeof E_UPLOADS>;
